export enum TipoGrafico {
    Oportunidades = 1,
    Telefones = 2,
    Emails = 3,
    SituacaoCPF = 4,
    PersonaGeracao = 5,
    Score = 6,
    PersonaDigital = 7,
    FlagsTelefonia = 8,
    FaixaSalarial = 9,
    Palavras = 10
}